import { createContext } from 'react'

const couponContext = createContext()

export default couponContext
